export default __webpack_public_path__ + "static/media/location.70a65922.svg";